import PropTypes from "prop-types";
import React from "react";

export const BettoSadFaceIcon = ({ size = 120 }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 120 120"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true">
		<circle
			cx="60"
			cy="60"
			r="50"
			fill="#2c313c"
		/>
		<circle
			cx="44"
			cy="50"
			r="6"
			fill="#a5b1c1"
		/>
		<circle
			cx="76"
			cy="50"
			r="6"
			fill="#a5b1c1"
		/>
		<path
			d="M38 80C46 68 74 68 82 80"
			stroke="#a5b1c1"
			strokeWidth="5"
			strokeLinecap="round"
		/>
	</svg>
);

BettoSadFaceIcon.propTypes = {
	size: PropTypes.number,
};
